/**
 * Hook to set up WebSocket stream callbacks for chat messages.
 * Handles new conversation routing and error toast notifications.
 */

import { setStreamHandlerCallbacks } from '@saaga/shared/store/middleware/engine-event-handlers.helper'
import { useEffect } from 'react'
import { toast } from 'sonner'

import { mapWebSocketError } from '@/utils/websocket-error.util'

interface UseStreamCallbacksParams {
  onNewConversation: (newConversationId: string) => void
  onConversationComplete?: () => void
}

export const useStreamCallbacks = ({
  onNewConversation,
  onConversationComplete,
}: UseStreamCallbacksParams): void => {
  useEffect(() => {
    setStreamHandlerCallbacks({
      onNewConversation: (newConversationId) => {
        onNewConversation(newConversationId)
      },
      onStreamError: (error) => {
        const mappedError = mapWebSocketError(error)
        toast.error(mappedError.message)
      },
      onConversationComplete: onConversationComplete ? () => onConversationComplete() : undefined,
    })

    return () => {
      setStreamHandlerCallbacks({})
    }
  }, [onNewConversation, onConversationComplete])
}
